import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import type { Maybe } from '@soundxyz/utils';
import { usePlayerTrackInfo } from '@components/AudioPlayer/usePlayerTrackInfo';
import { prefetchAudioFile } from '@store/audio/AudioFetcher';

// Prefetch audio information so playback is as seamless as possible
export const usePrefetchTrackInView = ({
  trackId,
  shouldFetch = true,
}: {
  trackId: Maybe<string>;
  shouldFetch?: boolean;
}) => {
  const { inView, ref: inViewRef } = useInView();

  const playerTrackInfo = usePlayerTrackInfo({
    trackId,
    shouldFetch: inView && shouldFetch,
  });

  const { trackAudioUrl } = playerTrackInfo;

  useEffect(() => {
    if (!trackAudioUrl || !inView) return;

    prefetchAudioFile({
      url: trackAudioUrl,
    });
  }, [trackAudioUrl, inView, trackId]);

  return { inViewRef, playerTrackInfo, inView };
};
